export class LatestVoyageData {
    constructor(voyageNumber: string | null, voyageNumber1: number | null, voyageNumber2: number | null) {
        this.voyageNumber = voyageNumber;
        this.voyageNumber1 = voyageNumber1;
        this.voyageNumber2 = voyageNumber2;
    }
    voyageNumber: string | null;
    voyageNumber1: number | null;
    voyageNumber2: number | null;
}
